import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { formatINR } from "@/lib/brand";

export default function OrderSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "checking" });
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let alive = true;
    const check = async () => {
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        if (!alive) return;
        setStatus(data);
        if (data.payment_status !== "paid" && tries < 8) setTimeout(() => setTries(t => t+1), 2000);
      } catch { if (alive) setStatus({ payment_status: "error" }); }
    };
    check();
    return () => { alive = false; };
    // eslint-disable-next-line
  }, [sessionId, tries]);

  return (
    <div className="min-h-screen flex items-center justify-center px-8 pt-24 text-ink" style={{ background: "#efe7d7" }}>
      <div className="text-center max-w-lg">
        <p className="text-[10px] tracking-luxury uppercase text-goldDark mb-8">
          {status.payment_status === "paid" ? "Confirmed" : "One moment"}
        </p>
        <h1 data-testid="order-success-heading" className="font-editorial text-5xl md:text-6xl leading-tight">
          {status.payment_status === "paid" ? "Thank you." : "Confirming"}
        </h1>
        <div className="rule-gold w-16 mx-auto my-8" />
        {status.order && (
          <>
            <p className="text-ink/70">Order #{status.order.id.slice(0,8).toUpperCase()}</p>
            <p className="text-sm text-ink/50 mt-2">{formatINR(status.order.total)} · Sent to {status.order.email}</p>
          </>
        )}
        <div className="mt-12 flex justify-center gap-4">
          <Link to="/account" className="tracking-widest-plus text-[11px] uppercase text-goldDark link-draw">View orders →</Link>
          <Link to="/" className="tracking-widest-plus text-[11px] uppercase text-ink/70 link-draw">Return home →</Link>
        </div>
      </div>
    </div>
  );
}
